// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useEffect, useRef, useState } from 'react';
import S from './style';

export interface DragPreviewProps {
}

const Drag = (props: DragPreviewProps): JSX.Element => {
  return (
    <S.Container>
      <S.Title>
        拖曳圖片上傳到對話
      </S.Title>
      <S.SubTitle>
        附上說明圖片，讓我們更了解怎麼幫助您吧！
      </S.SubTitle>
    </S.Container>
  )
}

export { Drag as default };
